export const KeycloakConfig = Object.freeze({
  ticketId: 'ticketId',
  trazabilityCode: 'trazabilityCode',
  loginPath: '/auth/login',
  minValidity: 30,
});
